<template>
  <div class="breadcrumbs_container">
    <img
      class="home_icon"
      width="15"
      height="15"
      src="../assets/home.svg"
      alt="home"
    />
    <v-breadcrumbs>
      <v-breadcrumbs-item
        class="breadcrumb_item"
        v-for="item in $root.breadcrumbs"
        :key="item.text"
        :to="item.href"
      >
        <img
          width="15"
          height="15"
          v-if="item.icon"
          :src="item.icon"
          :alt="item.text"
        />
        <span>{{ item.text }}</span>
      </v-breadcrumbs-item>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
};
</script>
<style scoped>
.breadcrumbs_container {
  height: 60px;
  background-color: #fff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 0px 18px;
}
.v-breadcrumbs {
  padding-left: 0;
}
.home_icon {
  margin-left: 10px;
  margin-right: 7px;
}
span {
  color: #2c4370;
  font-size: 16px;
  margin-top: 2px;
}
.breadcrumb_item img {
  margin-right: 15px;
  margin-left: 8px;
}
</style>
